import React, {useState, useEffect} from 'react';
import { Wrapper } from './style';

// Components
import Image from 'next/image'
import Link from 'components/common/Link';
import Text from 'components/common/Text';

// Configs
import { appConfig } from 'configs'
import Translation from 'libs/Translation';

const Footer = ({ webConfig }) => {
	const faLogosItems = [
		{ id: 0, src: '/nextasset/images/footer/eenamad.svg', link: 'https://trustseal.enamad.ir/?id=274676&Code=NKmzoxojPqZqbqnouxQV' },
		{ id: 1, src: '/nextasset/images/footer/OtherLogo.svg' },
	]
	const enLogosItems = [
		{ id: 0, src: '/nextasset/images/footer/Ccpa.jpeg' },
		{ id: 1, src: '/nextasset/images/footer/GDPR.jpeg' },
	]
	const [items, setItems] = useState(faLogosItems);

	const socials = [
		{ id: 0, src: '/nextasset/images/footer/whatsapp.svg', link: 'https://wa.me/989011743193' },
		{ id: 1, src: '/nextasset/images/footer/linkedin.svg', link: 'https://www.linkedin.com/company/vclinic/' },
		{ id: 2, src: '/nextasset/images/footer/instagram.svg', link: 'https://www.instagram.com/vclinic.io/' },
	]
	let others = [
		{ id: 1, title: Translation.t('label.phone-number'), text: Translation.t('text.footer-phone-number'), src: "/nextasset/images/footer/phone-flipped.svg" },
	]
	if (webConfig.lang === 'fa') {
		others.push({ id: 0, title: Translation.t('label.address'), text: Translation.t('text.footer-address'), src: "/nextasset/images/footer/pin.svg" });
	}

	useEffect(() => {
		if (webConfig.lang !== 'fa') {
			setItems(enLogosItems)
		}
		else {
			setItems(faLogosItems)
		}
	}, [webConfig.lang])


	const handleClick = () => {
    	window.open(
      		"https://logo.samandehi.ir/Verify.aspx?id=44068&p=aodsaodsobpdgvkamcsi",
      		"Popup",
      		"toolbar=no,scrollbars=no,location=no,statusbar=no,menubar=no,resizable=0,width=450,height=630,top=30"
    	);
  	};

	return (
	<Wrapper lang={webConfig.lang}>
		<div className='row-flex'>
			<div className='column'>
				<Link 
					to={appConfig.site_url}
					className="logo"
				>
					<Image
						src="/nextasset/images/logo-white.svg"
						alt="vclinic-logo"
						width={106}
						height={39}
					/>
				</Link>
				<Text 
					tag="p"
					className="text"
				>
					{Translation.t('text.footer')}
				</Text>

				{others.reverse().map(o => (
				<div 
					className='address'
					key={o.id}
				>
					<div className='title-section'>
						<Image
							src={o.src}
							alt="icon"
							width={18}
							height={18}
						/>
						<Text
							tag="span"
							className="title"
						>
							{o.title}
						</Text>
					</div>
					<Text 
						tag="p"
						className="text"
					>
						{o.text}
					</Text>
				</div>
				))}

			</div>
			
			<div className='column flex-end'>
				<div className='signs'>
					{webConfig.lang === 'fa' &&
					<img
      					id="wlaowlaoesgtfukzoeuk"
      					referrerPolicy="origin"
      					style={{ cursor: "pointer" }}
      					onClick={handleClick}
      					alt="Samandehi logo"
      					src="/nextasset/images/footer/samandehi.svg"
						className='sign'
						width={100}
						height={124}
    				/>
					}
					{items.map(i => (
						<a
							key={i.id}
							href={i.link}
							referrerPolicy="origin"
							target="_blank"
							rel="noreferrer"
							className='sign-item'
						>
							<img
								src={i.src}
								alt="icon"
								width={100}
								height={124}
								className='sign'
							/>
						</a>
					))}
				</div>
			</div>
		</div>

		<div className='row-flex'>
			<div className='copyright-section'>
				<Text 
					tag="p"
					className="weight-500 text"
				>	
					{Translation.t('text.footer-copyright')}
				</Text>
				<Text 
					tag="p"
					className="weight-500 text"
				>
					{Translation.t('text.footer-copyright-2')}
				</Text>
				<Text 
					tag="p"
					className="weight-500 text"
				>
					{Translation.t('text.footer-copyright-3')}
				</Text>
			</div>
			<div className='socials'>
				<Text 
					tag="p"
					className='weight-500 text follow-us'
				>
					{Translation.t('text.follow-us')}
				</Text>
				{socials.map(s => (
				<a 
					key={s.id}
					href={s.link}
					target="_blank"
					rel="noreferrer"
				>
					<Image
						src={s.src}
						alt="icon"
						width={24}
						height={24}
					/>
				</a>
				))}
			</div>
		</div>
	</Wrapper>
	);
};

export default Footer;
